import { SvgMrYumLogo } from '@mr-yum/frontend-ui'
import cn from 'classnames'
import React from 'react'
import { useAmplitude } from 'react-amplitude-hooks'
import { FormattedMessage } from 'react-intl'

interface Props {
  hasFloatingButton?: boolean | null
}

export const Footer: React.FC<Props> = ({ hasFloatingButton = false }) => {
  const { logEvent } = useAmplitude()

  return (
    <footer>
      <div className="pb-[max(0px,calc(2*env(safe-area-inset-bottom)))]">
        <div
          className={cn(
            'text-cent flex flex-col items-center justify-between bg-surface-ui-background px-4 pb-10 pt-6 text-foreground',
            {
              'pb-24': hasFloatingButton,
              'pb-10': !hasFloatingButton,
            },
          )}
        >
          <div className="mb-3 flex items-center justify-center">
            <div className="my-3 mr-3 my-label-sm">
              <FormattedMessage defaultMessage="Powered by" id="U8QBHO" />
            </div>

            <a
              href="https://www.mryum.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SvgMrYumLogo height={36} width={36} />
            </a>
          </div>

          <p className="mb-3 my-body-sm">
            <FormattedMessage
              defaultMessage="Beautiful menus for QR code table ordering, pickup delivery and payments."
              id="0KB2K4"
            />
          </p>

          <a
            className="underline my-body-sm-bold"
            href="https://www.mryum.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => logEvent('Clicked on learn more in footer')}
          >
            <FormattedMessage defaultMessage="Learn more" id="TdTXXf" />
          </a>
        </div>
      </div>
    </footer>
  )
}
